(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .controller('MetricChartCtrl', MetricChartCtrl)
      .directive('tfcMetricChart', tfcMetricChart);

  // @ngInject
  function MetricChartCtrl($stateParams, dateFilter, AnalyticsConfig, MetricConfig) {
    var vm = this;
    vm.options = null;
    vm.params = null;
    vm.dateError = null;
    vm.dateFormat = 'yyyy-MM-dd';
    vm.loading = false;
    vm.viewType = AnalyticsConfig.viewType($stateParams.experiment);
    vm.initMetric = initMetric;

    vm.intervalMap = _.reduce(vm.intervals, function (map, interval) {
      map[interval.interval] = interval;
      return map;
    }, {});

    var analyticsVm;

    vm.init = function (_analyticsVm) {
      analyticsVm = _analyticsVm;
    };

    vm.loadingOverlay = function (promise) {
      vm.loading = true;
      promise.finally(function () {
        vm.loading = false;
      });
    };

    vm.reload = function (force) {
      // close the date pickers when loading
      vm.startOpen = vm.endOpen = false;

      vm.dateError = null;
      // vm.params starts out null
      var isValid = vm.params == null || vm.isCurrentRangeValid();
      if (isValid === true) {
        // avoid re-fetching the same data
        if (force || !angular.equals(vm.params, initParams(vm.metric))) {
          vm.loadingOverlay(
              analyticsVm.loadMetric(vm.metricName, queryParams(vm.params))
          );
        }
      } else if (isValid !== false) {
        // isValid is the error type
        vm.dateError = 'error.dateRange.' + isValid;
      }
    };

    function queryParams(params) {
      params = _.extend({}, $stateParams, params);
      params.start = dateToStr(params.start);
      params.end = dateToStr(params.end);
      return params;
    }

    vm.isCurrentRangeValid = function () {
      return vm.isRangeValid(vm.params.interval, vm.params.start, vm.params.end);
    };

    vm.isRangeValid = function (interval, start, end) {
      if (!_.isDate(start) || isNaN(start.getTime()) ||
          !_.isDate(end) || isNaN(end.getTime())) {
        // either start or end is invalid
        return false;
      }
      // todo: test across DST boundaries
      // get 23:59 of the end date because analytics does the same thing
      end = new Date(end);
      end.setDate(end.getDate() + 1);
      end.setMinutes(end.getMinutes() - 1);
      var maxRange = vm.intervalMap[interval].maxRangeMs;
      var range = end - start;
      if (range < 0) {
        return 'negative';
      }
      if (range > maxRange) {
        return 'tooBig';
      }
      return true;
    };

    function fixDate(timestamp) {
      var date = new Date(timestamp);
      if (date.getMinutes()) {
        // adjust for timezone so the dates' times are always 00:00:00
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
      }
      return date;
    }

    function dateToStr(date) {
      return dateFilter(date, vm.dateFormat);
    }

    function initMetric(metric) {
      vm.options = MetricConfig.getChartOptions(metric);
      vm.metric = metric;
      vm.params = initParams(metric);
    }

    function initParams(metric) {
      return {
        interval : metric.interval.interval,
        start : fixDate(metric.startDate),
        end : fixDate(metric.endDate)
      };
    }
  }

  // @ngInject
  function tfcMetricChart() {
    return {
      require : ['tfcMetricChart', '^^tfcAnalyticsView'],
      controller : 'MetricChartCtrl as vm',
      bindToController : true,
      templateUrl : 'Analytics/MetricChart.tmpl.html',
      scope : {
        metricName : '@',
        hideControls : '&',
        intervals : '='
      },
      link : function ($scope, $el, $attrs, ctrls) {
        var vm = ctrls[0],
            analyticsVm = ctrls[1];
        vm.init(analyticsVm);
        // fired by the AnalyticsCtrl
        $scope.$on('chart.reload', function () {
          vm.reload(true);
        });
        $scope.$watch(function () {
          return analyticsVm.metricData(vm.metricName);
        }, function (data) {
          if (data) {
            vm.initMetric(data);
          }
        });
      }
    };
  }

})();
